import * as t from 'io-ts'
import { DateFromISOString } from 'io-ts-types'
import { nullable } from 'lib/request'

export const TTranslation = t.strict({
  language: t.string,
  text: t.string,
})

export const TTerm = t.strict({
  createdAt: DateFromISOString,
  description: nullable(t.string),
  key: t.string,
  tags: t.array(t.string),
  termId: t.string,
  updatedAt: DateFromISOString,
  translations: nullable(t.array(TTranslation)),
  linked: t.boolean,
})

export type Term = t.TypeOf<typeof TTerm>

export const TColumns = t.strict({
  showColumns: t.array(t.string),
})

export const TDuplicatedTerms = nullable(t.array(TTerm))

export type DuplicatedTerms = t.TypeOf<typeof TDuplicatedTerms>

export type TermKeyDirectory = {
  key: string
  directories: TermKeysDirectories | null
}

export type TermKeysDirectories = Array<TermKeyDirectory>

export const TTermKeysDirectoriesList: t.Type<TermKeysDirectories> =
  t.recursion('Directories', () =>
    t.array(
      t.strict({
        key: t.string,
        directories: nullable(TTermKeysDirectoriesList),
      }),
    ),
  )

const TTermImportItem = t.strict({
  lang: t.string,
  result: t.strict({
    duplicatedKeys: t.array(t.string),
    invalidKeys: t.array(t.string),
    newKeys: t.array(t.string),
    updatedKeys: t.array(t.string),
  }),
})

export type TermImportItem = t.TypeOf<typeof TTermImportItem>

export const TTermImportItems = t.array(TTermImportItem)

export type TermImportItems = t.TypeOf<typeof TTermImportItems>
